import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { companyApi } from '@/services/company';
import { UpdateCompanyRequest } from '@/types/company';

import { useAuth } from './auth';

const COMPANY_QUERY_KEY = 'company';

const COMPANY_STALE_TIME = 30000; // 30 seconds
const COMPANY_GC_TIME = 5 * 60 * 1000; // 5 minutes

export const COMPANY_QUERY_OPTIONS = {
  staleTime: COMPANY_STALE_TIME,
  gcTime: COMPANY_GC_TIME,
};

export function useCompany() {
  const { user } = useAuth();

  const query = useQuery({
    queryKey: [COMPANY_QUERY_KEY, user?.company_id],
    queryFn: () => companyApi.getCompany(user?.company_id || ''),
    ...COMPANY_QUERY_OPTIONS,
    enabled: !!user?.company_id,
  });

  return query;
}

export function useUpdateCompany() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: (data: UpdateCompanyRequest) =>
      companyApi.updateCompany(user?.company_id || '', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [COMPANY_QUERY_KEY] });
    },
  });
}
